import {
    ErrorResponse,
    GetShiftReportsRequest,
    ShiftReportsList,
} from "../../../api";
import { commonSlice, store } from "../../../store";

import {
    shiftMonitoringSlice,
    TableSortState,
} from "../../../features/ShiftMonitoring/store";
import { api } from "../../common/make_api";

import { ShiftsRequest } from "../../../api/models/ShiftsRequest";
import {
    ActionType,
    ResourceType,
    sendLog,
    StatusType,
} from "../../../services/common/send_log";
import { convertRequestMonth } from "../../common/convert";
import { Logout } from "../../login/login";

export const updateSortState = async (
    col: string,
    direction: string
): Promise<void> => {
    await store.dispatch(
        shiftMonitoringSlice.actions.update_table_sort({
            lastSortedColumn: col,
            sortDirection: direction,
        } as TableSortState)
    );
};

export async function selectShiftReports(): Promise<any> {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        store.dispatch(shiftMonitoringSlice.actions.update_shift_reports(null));

        const state = store.getState();
        let officeid: any = state.shifts.officeId ? state.shifts.officeId : -1;

        const sessionOfficeIds = state.common.officeIds;
        if (!sessionOfficeIds) {
            // office user
            officeid = state.common.selectedOfficeId;
        }

        const officeids = sessionOfficeIds ? sessionOfficeIds : undefined;

        const guidanceOnly = state.shifts.needGuidanceOnly;

        const shiftsRequest: ShiftsRequest = {
            officeId: officeid,
        };

        // multi-office user
        if (officeid == -1) {
            if (officeids) {
                shiftsRequest["officeIds"] = officeids;
            }
        }

        if (state.shifts.startDate) {
            const shitstart = convertRequestMonth(state.shifts.startDate);
            shiftsRequest["shiftStartDate"] = shitstart;
        }

        if (state.shifts.endDate) {
            const shiftend = convertRequestMonth(state.shifts.endDate);
            shiftsRequest["shiftEndDate"] = shiftend;
        }

        if (
            state.shifts.driverIds &&
            typeof state.shifts.driverIds[0] == typeof 2
        ) {
            shiftsRequest["driverIds"] = state.shifts.driverIds;
        }

        const req: GetShiftReportsRequest = {
            shiftsRequest: shiftsRequest,
        };

        const res = await api.getShiftReportsAPI().getShiftReports(req);

        sendLog(
            ResourceType.SHIFTS_MONITORING,
            StatusType.GET_RESOURCE,
            ActionType.SELECT_SHIFTS_REPORTS
        );

        if (guidanceOnly) {
            const _res = filterByGuidance(res);
            const _r = _res ? _res : null;
            store.dispatch(
                shiftMonitoringSlice.actions.update_shift_reports(_r)
            );
            return _res;
        }
        store.dispatch(shiftMonitoringSlice.actions.update_shift_reports(res));
        store.dispatch(shiftMonitoringSlice.actions.update_table_sort(null));

        return res;
    } catch (err) {
        console.log("Got this error from shift_reports:", err);
        if (err["status"] == 401) {
            console.log("Session has expired");
            Logout();
            return;
        }

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return null;
        }
        const res = (await (err as Response).json()) as ErrorResponse;
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}

const filterByGuidance = (res: ShiftReportsList) => {
    const _s = res.shiftReports;
    if (!_s) {
        return null;
    }

    const _f = _s.filter((x) => {
        return (
            x.needGuidanceBreaks == "required" ||
            x.needGuidanceEarnings == "required" ||
            x.needGuidanceHermes == "required"
        );
    });

    return { shiftReports: _f } as ShiftReportsList;
};
